import { gql } from '@apollo/client';

const CLINIC_DATA_QUERY = gql`
  query getClinicData($filter: ClinicDataFilter!) {
    getClinicData(filter: $filter) {
      isSuccess
      message
      start
      stop
      ecgDataMap {
        samplingFrequency
        gain
        channels
        data {
          start
          stop
          sampleSize
          dataUrl
          hrUrl
        }
        querySignature
      }
    }
  }
`;

export default CLINIC_DATA_QUERY;
